import { NgModule } from '@angular/core';
import { MyOffersComponent } from './my-offers.component';
import { ConfigModule, CmsConfig } from '@spartacus/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SafePipe } from '../shared/pipe/safe';
import { DatePipe, NgClass } from '@angular/common';
import { OfferDocumentComponent } from './components/offer-document/offer-document.component';
import { OfferFormComponent } from './components/offer-form/offer-form.component';
import { OfferComponent } from './components/offer/offer.component';
import { TrimSpacesDirective } from './directives/trim-spaces/trim-spaces.directive';

@NgModule({
  declarations: [
    MyOffersComponent,
    OfferComponent,
    SafePipe,
    OfferDocumentComponent,
    OfferFormComponent,
    TrimSpacesDirective
  ],
  imports: [
    ReactiveFormsModule,
    DatePipe,
    NgClass,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        OfferPageComponent: {
          component: MyOffersComponent,
        },
      },
    }),
  ]
})
export class MyOffersModule { }
